import { a as __makeTemplateObject, _ as __assign } from './tslib.es6-86dc5b0c.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import styled, { keyframes } from 'styled-components';

var Container = styled.div(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  align-items: center;\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  left: -9999px;\n  margin: auto;\n  opacity: 0;\n  position: absolute;\n  right: 0;\n  top: -9999px;\n  visibility: hidden;\n\n  ", "\n\n  ", "\n"], ["\n  align-items: center;\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  left: -9999px;\n  margin: auto;\n  opacity: 0;\n  position: absolute;\n  right: 0;\n  top: -9999px;\n  visibility: hidden;\n\n  ", "\n\n  ", "\n"])), function (_a) {
    var themeValues = _a.themeValues;
    return "\n      transition: opacity " + themeValues.transitionDuration + " ease,\n        visibility " + themeValues.transitionDuration + " step-start;\n    ";
}, function (_a) {
    var isLoading = _a.isLoading;
    if (isLoading) {
        return "\n        left: 0;\n        opacity: 1;\n        top: 0;\n        visibility: visible;\n      ";
    }
});
Container.displayName = 'Container';
var templateObject_1$2;

var Label = styled.p(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  letter-spacing: 0.1px;\n  text-transform: uppercase;\n\n  ", "\n"], ["\n  letter-spacing: 0.1px;\n  text-transform: uppercase;\n\n  ", "\n"])), function (_a) {
    var themeValues = _a.themeValues;
    return "\n    color: " + themeValues.labelColor + ";\n    font: 600 13px/16px " + themeValues.fontFamily + ";\n  ";
});
Label.displayName = 'Label';
var templateObject_1$1;

var spin = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  from { transform: rotate(0deg); }\n  to { transform: rotate(359deg); }\n"], ["\n  from { transform: rotate(0deg); }\n  to { transform: rotate(359deg); }\n"])));
var SpinnerSvg = styled.svg.attrs(function () { return ({
    height: 66,
    width: 66,
}); })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  animation-duration: 1s;\n  animation-iteration-count: infinite;\n  animation-name: ", ";\n  animation-timing-function: linear;\n"], ["\n  animation-duration: 1s;\n  animation-iteration-count: infinite;\n  animation-name: ", ";\n  animation-timing-function: linear;\n"])), spin);
var Spinner = function (props) { return (jsx(SpinnerSvg, { children: jsx("path", { d: "M35.473 1.094A32.447 32.447 0 0 0 33 1C15.327 1 1 15.327 1 33c0 6.77 2.102 13.049 5.69 18.22", fill: "none", stroke: props.themeValues.spinnerColor }, void 0) }, void 0)); };
Spinner.displayName = 'Spinner';
var templateObject_1, templateObject_2;

var loadingIndicatorDefaultThemeValues = {
    fontFamily: 'proxima-nova, sans-serif',
    labelColor: '#333',
    spinnerColor: '#979797',
    transitionDuration: '250ms',
};
/**
 * An indeterminate loading indicator with optional label
 */
var LoadingIndicator = function (props) {
    var className = props.className, _a = props.isLoading, isLoading = _a === void 0 ? false : _a, _b = props.themeValues, themeValuesFromProps = _b === void 0 ? {} : _b, label = props.label;
    var themeValues = {
        fontFamily: themeValuesFromProps.fontFamily ||
            loadingIndicatorDefaultThemeValues.fontFamily,
        labelColor: themeValuesFromProps.labelColor ||
            loadingIndicatorDefaultThemeValues.labelColor,
        spinnerColor: themeValuesFromProps.spinnerColor ||
            loadingIndicatorDefaultThemeValues.spinnerColor,
        transitionDuration: themeValuesFromProps.transitionDuration ||
            loadingIndicatorDefaultThemeValues.transitionDuration,
    };
    return (jsxs(Container, __assign({ className: className, isLoading: isLoading, themeValues: themeValues }, { children: [jsx(Spinner, { themeValues: themeValues }, void 0), label && jsx(Label, __assign({ themeValues: themeValues }, { children: label }), void 0)] }), void 0));
};

export { LoadingIndicator as L, loadingIndicatorDefaultThemeValues as l };
